import React from "react";

const UploadModeSelector = ({ selectedMode, setSelectedMode, setFiles, onBack, onContinue }) => {

    const handleQuickSend = () => {
        setSelectedMode("quick");

        setFiles(prev =>
            prev.map(file => ({
                ...file,
                printOptions: {
                    paperSize: "",
                    quality: "",
                    quantity: "",
                    paperType: "",
                    paperThickness: "",
                    orientation: "",
                    color: "TBD",
                    binding: "",
                    doubleSided: "",
                    printNeedBy: "",
                    additionalNotes: "",
                },
            }))
        );
    };

    return (
        <div className="flex-1 flex items-start justify-center p-[16px] md:p-[40px]">
            <div className="w-full max-w-[720px] bg-white rounded-[16px] shadow-[0px_2px_28px_0px_rgba(0,0,0,0.07)] p-[24px] md:p-[40px] flex flex-col gap-[28px]">

                {/* Header */}
                <div>
                    <h1 className="font-semibold text-[24px] text-[#212326] mb-[6px]">
                        How would you like to proceed?
                    </h1>
                    <p className="font-medium text-[14px] text-[#717182]">
                        Send your files as-is or customise print requirements first.
                    </p>
                </div>

                {/* Options */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-[16px]">

                    {/* QUICK SEND */}
                    <button
                        onClick={handleQuickSend}
                        className={`text-left p-[24px] rounded-[14px] border-2 transition-all
                            ${selectedMode === "quick"
                                ? "border-[#ff5323] bg-[#fff5f2]"
                                : "border-[#e4e5e7] hover:border-[#c0c2c6]"
                            }`}
                    >
                        <div className="flex items-start gap-[16px]">
                            <div className={`w-[48px] h-[48px] rounded-[12px] flex items-center justify-center shrink-0
                                ${selectedMode === "quick" ? "bg-[#ff5323]" : "bg-[#f4f5f6]"}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                                    className={`w-[22px] h-[22px] ${selectedMode === "quick" ? "text-white" : "text-[#53585f]"}`}>
                                    <path d="M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z" />
                                </svg>
                            </div>

                            <div>
                                <p className="font-semibold text-[17px] text-[#212326] mb-[4px]">
                                    Quick Send
                                </p>
                                <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                                    Just upload and send. Let the print shop handle the details.
                                </p>
                            </div>
                        </div>
                    </button>

                    {/* REQUIREMENTS */}
                    {/* ===========================
    SET PRINT REQUIREMENTS
    (Original - Commented for future use)
===========================

<button
    onClick={() => setSelectedMode("custom")}
    className={`text-left p-[24px] rounded-[14px] border-2 transition-all
        ${selectedMode === "custom"
            ? "border-[#ff5323] bg-[#fff5f2]"
            : "border-[#e4e5e7] hover:border-[#c0c2c6]"
        }`}
>
    <div className="flex items-start gap-[16px]">
        <div className={`w-[48px] h-[48px] rounded-[12px] flex items-center justify-center shrink-0
            ${selectedMode === "custom" ? "bg-[#ff5323]" : "bg-[#f4f5f6]"}`}>
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                className={`w-[22px] h-[22px] ${selectedMode === "custom" ? "text-white" : "text-[#53585f]"}`}>
                <path d="M20 7h-9" />
                <path d="M14 17H5" />
                <circle cx="17" cy="17" r="3" />
                <circle cx="7" cy="7" r="3" />
            </svg>
        </div>

        <div>
            <p className="font-semibold text-[17px] text-[#212326] mb-[4px]">
                Set Print Requirements
            </p>
            <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                Specify paper size, print type, quantity, and other preferences.
            </p>
        </div>
    </div>
</button>

=========================== */}

                    {/* COMING SOON */}
                    <button
                        disabled
                        className="relative text-left p-[24px] rounded-[14px] border-2 border-[#e4e5e7] bg-[#fafafa] opacity-70 cursor-not-allowed"
                    >
                        {/* Badge */}
                        <div className="absolute -top-[10px] left-[20px]">
                            <span className="px-[10px] py-[4px] rounded-full bg-[#ff5323] text-white text-[11px] font-semibold uppercase tracking-[0.4px] shadow-sm">
                                Coming Soon
                            </span>
                        </div>

                        <div className="flex items-start gap-[16px]">
                            <div className="w-[48px] h-[48px] rounded-[12px] bg-[#f4f5f6] flex items-center justify-center shrink-0">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    className="w-[22px] h-[22px] text-[#9298a0]"
                                >
                                    <path d="M20 7h-9" />
                                    <path d="M14 17H5" />
                                    <circle cx="17" cy="17" r="3" />
                                    <circle cx="7" cy="7" r="3" />
                                </svg>
                            </div>

                            <div>
                                <p className="font-semibold text-[17px] text-[#212326] mb-[4px]">
                                    Set Print Requirements
                                </p>
                                <p className="font-medium text-[13px] text-[#717182] leading-[1.5]">
                                    Specify paper size, print type, quantity, and other preferences.
                                </p>
                            </div>
                        </div>
                    </button>
                </div>

                {/* Footer */}
                <div className="flex flex-col-reverse md:flex-row md:justify-between gap-[10px]">
                    <button
                        className="flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] py-[12px] rounded-[10px] border border-[#e4e5e7] font-semibold text-[15px] text-[#212326] hover:bg-[#f4f5f6] transition-colors"
                        onClick={onBack}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-left w-[16px] h-[16px]">
                            <path d="m15 18-6-6 6-6"></path>
                        </svg>
                        Back
                    </button>

                    <button
                        disabled={!selectedMode}
                        onClick={onContinue}
                        className={`flex items-center justify-center gap-[8px] w-full md:w-auto px-[20px] md:px-[28px] py-[12px] rounded-[10px] font-semibold text-[15px] transition-all
                        ${!selectedMode
                                ? "bg-[#e4e5e7] text-[#9298a0] cursor-not-allowed"
                                : "bg-[#ff5323] text-white hover:bg-[#e64a1f]"
                            }`}
                    >
                        Continue
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right w-[16px] h-[16px]">
                            <path d="M5 12h14"></path>
                            <path d="m12 5 7 7-7 7"></path>
                        </svg>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UploadModeSelector;